// Which scopes to offer and the chosen one; ScopeMenu is the view.
const ScopeSelector = {
  props: {
    showAll: {
      required: true,
      type: Boolean,
    },
    userDefault: {
      required: true,
      type: String,
    },
    originalScope: {
      required: false,
      type: String,
    },
    initialScope: {
      required: false,
      type: String,
    },
  },
  emits: ['change'],
  data() {
    return {
      currentScope: this.initialScope,
    }
  },
  computed: {
    showNothing() {
      return (
        !this.showPublic &&
        !this.showUnlisted &&
        !this.showLocal &&
        !this.showPrivate &&
        !this.showDirect
      )
    },
    showPublic() {
      return this.originalScope !== 'direct' && this.shouldShow('public')
    },
    showUnlisted() {
      return this.originalScope !== 'direct' && this.shouldShow('unlisted')
    },
    // local-only: not in a reply to a direct message
    showLocal() {
      return this.originalScope !== 'direct' && this.shouldShow('local')
    },
    showPrivate() {
      return this.originalScope !== 'direct' && this.shouldShow('private')
    },
    showDirect() {
      return this.shouldShow('direct')
    },
  },
  methods: {
    shouldShow(scope) {
      return (
        this.showAll ||
        this.currentScope === scope ||
        this.originalScope === scope ||
        this.userDefault === scope ||
        scope === 'direct'
      )
    },
    changeVis(scope) {
      this.currentScope = scope
      this.$emit('change', scope)
    },
  },
  watch: {
    originalScope(newVal) {
      this.currentScope = newVal
    },
  },
}

export default ScopeSelector
